<template>
  <div class="user">
    <div class="openNotifications cursor-pointer" @click="openNotifications('COMPANY')" v-click-outside="hideCompany">
      <font-awesome-icon icon="university" size="2x"/>
      <span>{{ " " + selectedCompanyName(selectedCompany) }}</span>
      <img src="@/assets/images/arrow-down.svg"/>
      <div class="notification-box" v-show="isOpenCompany">
        <div class="main-notification">
          <table cellpadding="10" cellspacing="0" width="100%" style="text-align: left" align="center"
                 class="hover-table">
            <template v-for="companyListItem in this.user.companies">
              <tr v-if="companyListItem.active" :key="companyListItem.company_id"
                  @click="selectCompany(companyListItem)"
                  class="trhover" :class="selectedCompany.company_id === companyListItem.company_id && 'gri-cell'
              ">
                <td class="notification-footer" v-if="companyListItem.role !== 'FLX'">
                  <p>
                    <font-awesome-icon icon="university"/>

                    {{ selectedCompanyName(companyListItem) }}
                  </p>
                </td>
                <td class="notification-footer" style="text-align: right" v-if="companyListItem.company_id > 0">
                  <p>{{ companyListItem.company_id }}</p>
                </td>
              </tr>
            </template>
          </table>
        </div>
      </div>
    </div>
    <div>
      <img src="@/assets/images/linie.png"/>
    </div>
    <div class="openUserMenu" v-click-outside="hide" @click="openUserMenu()">
      <img src="@/assets/images/settings.png"/>
      <a href="#">{{ selectedCompanyName(selectedCompany) }}</a>

      <div class="userMenu" v-show="isOpen">
        <a :href="this.user.role === 'AFF'
          ? '/affiliate/account'
          : '/customer/account'
          " class="account" :class="this.menuSelected.account && 'account-active'">{{ $t("title.settingsName") }}</a>
        <a :href="this.user.role === 'AFF' ? '/affiliate/faq' : '/customer/faq'" class="faq"
           :class="this.menuSelected.faq && 'faq-active'">{{ $t("title.faqName") }}</a>
        <a v-if="this.company.role === 'FAC'" href="#" class="logout" @click="deselect()">{{
            $t("title.deselectName")
          }}</a>
        <a v-else href="#" class="logout" @click="logout()">{{
            $t("title.logoutName")
          }}</a>
      </div>
    </div>
    <!-- <LanguageBar @languageChanged="languageChanged" v-if="this.user.role !== 'AFF'" /> -->
  </div>
</template>
<script>
import Cookies from "js-cookie";
// import httpServiceCustomer from "@/http/http-customer.js";
import utils from "@/utils.js";
import ClickOutside from "vue-click-outside";
// import LanguageBar from "@/components/LanguageBar.vue";
// import NotificationsBox from "@/components/NotificationsBox.vue";

export default {
  name: "TopBarCompany",
  setup() {
    const {logoutCompany} = utils();
    return {
      logoutCompany
    }
  },
  props: {
    user: Object,
    company: Object,
    companyMessages: Array
  },
  directives: {
    ClickOutside
  },
  components: {
    // LanguageBar,
    // NotificationsBox
  },
  data() {
    return {
      customerMessages: null,
      menuSelected: {
        faq: false,
        account: false
      },
      userLink: "",
      token: "",
      readMessagesCount: 0,
      isOpenNotification: false,
      isOpenCompany: false,
      isOpen: false,
      selectedCompany: this.user.companies[0],
      dataLoaded: false,
      config: JSON.parse(localStorage.getItem("jsonFile"))
    };
  },
  methods: {
    openUserMenu() {
      this.isOpen = !this.isOpen;
    },
    openNotifications(windowType) {
      if (windowType === "NOTIFICATION") {
        this.loadMessages();
        this.isOpenNotification = !this.isOpenNotification;
        this.isOpenCompany = false;
      }
      if (windowType === "COMPANY") {
        this.isOpenCompany = !this.isOpenCompany;
        this.isOpenNotification = false;
      }
    },
    // isReadNotification(message) {
    //   message.read = true;
    //   httpServiceCustomer.customerService
    //     .markMessageAsRead(message, this.token)
    //     .catch(error => { });
    // },
    // loadMessages() {
    //   let formData =
    //     "?user_id=" +
    //     this.company.company_id +
    //     "&lang=" +
    //     localStorage.language;
    //   httpServiceCustomer.customerService
    //     .getMessages(formData, this.token)
    //     .then(function (response) {
    //       // handle success
    //       return response;
    //     })
    //     .then(response => {
    //       // total no of messages X-Up-Count
    //       // no of read messages
    //       this.readMessagesCount = response.headers["x-up-count1"];
    //       // no of unread messages X-Up-Count2
    //       this.customerMessages = response.data;
    //     })
    //     .catch(error => {
    //       // handle error
    //     });
    // },
    hide() {
      this.isOpen = false;
    },
    // hideNotification() {
    //   this.isOpenNotification = false;
    // },
    hideCompany() {
      this.isOpenCompany = false;
    },
    logout() {
      this.logoutCompany(this.user.id, Cookies.get("token"));
      Cookies.remove("userLink");
      Cookies.remove("token");
      this.$router.push({
        name: "login",
        params: {loginUserSelected: false}
      });
      this.$emit("sendUserRole", "", "");
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    deselect() {
      sessionStorage.setItem('selectedCompany', JSON.stringify({
        company_id: 0,
        role: "FAC"
      }));
      localStorage.removeItem("customer_data");
      localStorage.removeItem("affiliate_data");
      window.location.href = "/company/search";
    },
    selectCompany(company) {
      sessionStorage.setItem('selectedCompany', JSON.stringify({
        company_id: company.company_id,
        role: company.role
      }));

      localStorage.removeItem("affiliate_data");
      localStorage.removeItem("customer_data");
      window.location.href = "/company";
    },
    languageChanged() {
      this.$emit("languageChanged");
    },
    selectedCompanyName(company) {
      if (company.company_id > 0) {
        return company.company_id + " " + company.name;
      } else {
        return this.$t('title.userTypeLabel_' + company.role);
      }
    }
  },
  computed: {
    selectedCompany() {
      let selectedCompany = this.company;
      if (this.company.company_id > 0) {
        return this.company;
      } else {
        // selectedCompany = Cookies.getJSON("selectedCompany");
        selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
        if (!selectedCompany) {
          return this.user.companies[0];
        } else {
          for (let index in this.user.companies) {
            if (selectedCompany.company_id === this.user.companies[index].company_id) {
              return this.user.companies[index];
            }
          }
        }
      }
      return null;
    }
  },
  created() {
    switch (this.$route.name) {
      case "customer_faq":
        this.menuSelected.faq = true;
        break;
      case "customer_account":
        this.menuSelected.account = true;
        break;
    }
    this.selectedCompany = JSON.parse(sessionStorage.getItem("selectedCompany"));
    //  Cookies.getJSON("selectedCompany");
    if (!this.selectedCompany) {
      this.selectedCompany = this.user.companies[0];
    }
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
<style>
.openNotifications {
  position: relative;
}

.openNotifications img {
  cursor: pointer;
}

.unread-notifications {
  position: absolute;
  top: -10px;
  right: -7px;
  background: #f79000;
  border-radius: 100%;
  padding: 0;
  font-size: 12px;
  color: #fff;
  height: 18px;
  width: 18px;
  text-align: center;
}

.notification-box {
  position: absolute;
  top: 46px;
  right: -10px;
  width: 300px;
  background: #fff;
  padding: 20px;
  text-align: left;
  height: 335px;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2);
}

.main-notification {
  padding: 10px;
  cursor: pointer;
  border-bottom: 1px solid #dcdee3;
}

.main-notification:nth-child(1) {
  border-top: 1px solid #dcdee3;
}

.main-notification.unread {
  background: #eaeaea;
}

.notification-title {
  position: relative;
}

.notification-title h6 {
  font-size: 12px;
  margin: 0 0 10px;
  padding: 5px 0 0 25px;
  display: inline-block;
}

.notification-title img {
  width: 20px;
  position: absolute;
}

.notification-content h6 {
  font-size: 14px;
}

.notification-content p {
  font-size: 12px;
}

.notification-footer p {
  font-size: 12px;
  font-weight: bold;
  margin: 0;
}

.notification-footer p span {
  color: #f79000;
}

.main-notification.read {
  background: #fff;
}

.notification-header-container {
  width: 100%;
}

.notification-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.notification-header a {
  padding: 10px;
  background: #ddd;
  text-align: center;
  font-weight: 600;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  cursor: pointer;
  flex: 1 1 auto;
  border: 1px solid #ddd;
  border-bottom: 0 none;
  color: #585858;
}

.notification-header a:hover {
  background: #f1f1f1;
}

.notification-header a.active {
  background: #fff !important;
}

.notification-wrapper {
  border: 1px solid #ddd;
  position: relative;
  height: 250px;
  overflow-y: auto;
}

.notification-wrapper .notification-white-bar {
  height: 1px;
  background: #fff;
  width: calc(50% - 0.25rem + 3px);
  display: block;
  position: absolute;
  top: -1px;
}

.notification-action-button {
  font-weight: 100;
  font-size: 12px;
}

.user .notification-view-all {
  padding: 5px 10px;
  color: #fff;
  text-transform: initial;
  border: 0 none;
  font-weight: 600;
  display: block;
  margin-top: 10px;
  background: #f49400;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}

a.notification-delete-button {
  border: 1px solid #f59100;
  background: transparent;
  color: #f59100 !important;
  font-size: 12px;
  font-weight: 100;
}

.notification-action-select {
  margin: 0 !important;
  max-width: 200px;
  display: block;
}

#modal_popup_mobileNotifications .modal-popup-content {
  height: 100%;
  color: #4a4a4a;
  padding: 20px;
  max-height: calc(100vh - 20%);
}

#modal_popup_mobileNotifications .main-notification {
  text-align: left;
}

#modal_popup_mobileNotifications .notifications {
  max-height: calc(100vh - 20% - 20px);
  overflow-y: auto;
}

.transaction-title,
.download-wrapper {
  display: inline-block;
  width: auto;
}

.download {
  height: 40px;
  position: relative;
  top: -2px;
  cursor: pointer;
}

.services-content .app-platform {
  font-weight: bold;
}

.noNotifications > p {
  text-align: center;
  color: #a2a2a2;
  border-bottom: 1px solid #dcdee3;
  padding-bottom: 10px;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
}
</style>
